export default "__VITE_ASSET__Be8ig4Pr__"